export class Api {
    static get(method, data) {
        return BX.ajax.runAction('m204:orders.Mkb.' + method, {
            data: data
        });
    }
}